import { Pipe, PipeTransform } from '@angular/core';
import { DumpsterLocationService } from '@veritas-dumpsters/services/dumpster-location.service';

@Pipe({
  name: 'coordinate'
})
export class CoordinatePipe implements PipeTransform {

  constructor(private locationService: DumpsterLocationService){}

  transform(latitude: number, longitude: number, fixDecimal?: number): string {
    const coordinate = this.locationService.getLocationString(latitude, longitude, fixDecimal);
    
    if (!coordinate) return '';
    return coordinate;
  }

}
